import React, { useState, useEffect } from "react"
import BreadcrumbsSection from "./BreadcrumbsSection"
import Header from "./ui/Header"
import HomePage from "./HomePage"
import ContentPage from "./ContentPage"
import TopRightPageBg from "../Site/TopRightPageBg"

/**
 * Main layout component for the Help Center
 * Controls the overall structure based on whether we're on the homepage or content page
 */
const HomeLayout = ({
  isHomePage,
  breadcrumbs = [],
  refreshKey,
  currentLanguage,
  searchState,
  onSearchResultSelect,
  rootCategoriesData,
  onArticleSelect,
  onCategorySelect,
  expandedCategories,
  currentPath,
  isLoading,
  error,
  selectedContent,
  contentType,
  onFeedback,
  navigateTo,
}) => {
  // Client-side hydration protection for breadcrumbs
  const [isClient, setIsClient] = useState(false)
  
  useEffect(() => {
    setIsClient(true)
  }, [])

  // Only show breadcrumbs after client hydration to prevent SSR mismatch
  const shouldShowBreadcrumbs = isClient && !isHomePage && breadcrumbs.length > 0

  return (
    <div
      className={`relative w-full flex flex-col bg-gradient_hc_home rounded-b-[50px] md:rounded-b-[100px] overflow-x-hidden px-4 md:px-px1_l xl:px-px1_xl`}
      key={`help-center-${refreshKey}-${currentLanguage}`} // Force re-render on language change
    >
      {/* Header component */}
      <Header
        searchState={searchState}
        onSearchResultSelect={onSearchResultSelect}
      />

      <TopRightPageBg />

      {/* Breadcrumbs navigation - only show when not on homepage and after client hydration */}
      {shouldShowBreadcrumbs && (
        <BreadcrumbsSection items={breadcrumbs} />
      )}

      {/* Container for max-width and proper side margins */}
      <div className="w-full max-w-w2_xl flex-grow flex mx-auto">
        {isHomePage ? (
          /* Full-width layout for homepage */
          <HomePage />
        ) : (
          /* Split layout for article/category pages */
          <ContentPage
            rootCategoriesData={rootCategoriesData}
            onArticleSelect={onArticleSelect}
            onCategorySelect={onCategorySelect}
            expandedCategories={expandedCategories}
            currentPath={currentPath}
            isLoading={isLoading}
            error={error}
            selectedContent={selectedContent}
            contentType={contentType}
            onFeedback={onFeedback}
            navigateTo={navigateTo}
          />
        )}
      </div>
    </div>
  )
}

export default HomeLayout
